import patient from './patient';
import units from './units';

const modules = {
  patient: patient,
  units: units,
};

export default modules;
